import type { InvoiceStatus } from '@/lib/api/domains/invoices';
import type { StatusTone } from '@/components/composed/StatusBadge';

/*
 * Domain knowledge: how invoice statuses map to labels + status tones. Lives in
 * the feature (StatusBadge itself is domain-free; it just renders a tone).
 */
const STATUS_META: Record<InvoiceStatus, { label: string; tone: StatusTone }> =
  {
    draft: { label: 'Draft', tone: 'neutral' },
    open: { label: 'Open', tone: 'info' },
    paid: { label: 'Paid', tone: 'success' },
    void: { label: 'Void', tone: 'neutral' },
    overdue: { label: 'Overdue', tone: 'danger' },
  };

export function invoiceStatusMeta(status: InvoiceStatus) {
  return STATUS_META[status];
}
